<div
  class="tw-relative tw-border tw-flex-1 tw-max-w-full tw-transition-all tw-duration-200 hover:tw-border-blue-600 dark:hover:tw-border-blue-500 tw-group tw-flex tw-justify-center tw-items-center tw-gap-1.5 md:tw-min-w-[512px] md:tw-min-h-[147px] tw-p-2 tw-rounded-md tw-cursor-pointer group-hover:tw-scale-105"
  [ngClass]="{
    'tw-bg-blue-50 dark:tw-bg-gray-900 tw-border-blue-300 dark:tw-border-blue-800': isSelected(),
    'tw-bg-white dark:tw-bg-gray-800 tw-border-gray-200 dark:tw-border-gray-600': !isSelected()
  }"
  (click)="onCardClick()"
>
  <!-- Card Content -->
  <div class="tw-gap-1.5 tw-min-w-full md:tw-gap-3 tw-font-inter">
    <!-- 2-Column Layout: Image + Info -->
    <div class="tw-flex tw-gap-1.5 md:tw-gap-3">
      <!-- Left Column: Organization Icon/Logo -->
      <div class="tw-flex-shrink-0">
        <div
          class="tw-bg-transparent tw-flex tw-items-center tw-justify-center tw-w-[90px] tw-h-[90px] md:tw-w-[115px] md:tw-h-[115px] tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-gap-2.5 tw-overflow-hidden"
          [ngClass]="{ 'tw-bg-white': organization().logo }"
        >
          @if (organization().logo) {
          <img [src]="organization().logo" [alt]="organization().name" class="tw-object-contain tw-w-full tw-h-full tw-rounded-xl" />
          } @else {
          <svg class="md:tw-w-16 md:tw-h-16 tw-w-10 tw-h-10 tw-text-gray-400 dark:tw-text-gray-200" viewBox="0 0 65 65" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_5023_22286)">
              <path
                d="M60.9444 57.3888H57.3888V7.6111C58.3318 7.6111 59.2362 7.2365 59.903 6.5697C60.5698 5.90291 60.9444 4.99854 60.9444 4.05555C60.9444 3.11256 60.5698 2.20819 59.903 1.5414C59.2362 0.874601 58.3318 0.5 57.3888 0.5H7.6111C6.66811 0.5 5.76374 0.874601 5.09695 1.5414C4.43015 2.20819 4.05555 3.11256 4.05555 4.05555C4.05555 4.99854 4.43015 5.90291 5.09695 6.5697C5.76374 7.2365 6.66811 7.6111 7.6111 7.6111V57.3888H4.05555C3.11256 57.3888 2.20819 57.7634 1.5414 58.4302C0.874601 59.097 0.5 60.0014 0.5 60.9444C0.5 61.8874 0.874601 62.7917 1.5414 63.4585C2.20819 64.1253 3.11256 64.4999 4.05555 64.4999H60.9444C61.8874 64.4999 62.7917 64.1253 63.4585 63.4585C64.1253 62.7917 64.4999 61.8874 64.4999 60.9444C64.4999 60.0014 64.1253 59.097 63.4585 58.4302C62.7917 57.7634 61.8874 57.3888 60.9444 57.3888ZM18.2778 14.7222C18.2778 13.7792 18.6524 12.8748 19.3192 12.208C19.9859 11.5413 20.8903 11.1667 21.8333 11.1667H25.3889C26.3318 11.1667 27.2362 11.5413 27.903 12.208C28.5698 12.8748 28.9444 13.7792 28.9444 14.7222V18.2778C28.9444 19.2207 28.5698 20.1251 27.903 20.7919C27.2362 21.4587 26.3318 21.8333 25.3889 21.8333H21.8333C20.8903 21.8333 19.9859 21.4587 19.3192 20.7919C18.6524 20.1251 18.2778 19.2207 18.2778 18.2778V14.7222ZM18.2778 32.5V28.9444C18.2778 28.0014 18.6524 27.097 19.3192 26.4303C19.9859 25.7635 20.8903 25.3889 21.8333 25.3889H25.3889C26.3318 25.3889 27.2362 25.7635 27.903 26.4303C28.5698 27.097 28.9444 28.0014 28.9444 28.9444V32.5C28.9444 33.4429 28.5698 34.3473 27.903 35.0141C27.2362 35.6809 26.3318 36.0555 25.3889 36.0555H21.8333C20.8903 36.0555 19.9859 35.6809 19.3192 35.0141C18.6524 34.3473 18.2778 33.4429 18.2778 32.5ZM39.6111 57.3888H25.3889V46.7222C25.3889 45.7792 25.7635 44.8748 26.4303 44.208C27.097 43.5412 28.0014 43.1666 28.9444 43.1666H36.0555C36.9985 43.1666 37.9029 43.5412 38.5697 44.208C39.2365 44.8748 39.6111 45.7792 39.6111 46.7222V57.3888ZM46.7222 32.5C46.7222 33.4429 46.3476 34.3473 45.6808 35.0141C45.014 35.6809 44.1096 36.0555 43.1666 36.0555H39.6111C38.6681 36.0555 37.7637 35.6809 37.0969 35.0141C36.4301 34.3473 36.0555 33.4429 36.0555 32.5V28.9444C36.0555 28.0014 36.4301 27.097 37.0969 26.4303C37.7637 25.7635 38.6681 25.3889 39.6111 25.3889H43.1666C44.1096 25.3889 45.014 25.7635 45.6808 26.4303C46.3476 27.097 46.7222 28.0014 46.7222 28.9444V32.5ZM46.7222 18.2778C46.7222 19.2207 46.3476 20.1251 45.6808 20.7919C45.014 21.4587 44.1096 21.8333 43.1666 21.8333H39.6111C38.6681 21.8333 37.7637 21.4587 37.0969 20.7919C36.4301 20.1251 36.0555 19.2207 36.0555 18.2778V14.7222C36.0555 13.7792 36.4301 12.8748 37.0969 12.208C37.7637 11.5413 38.6681 11.1667 39.6111 11.1667H43.1666C44.1096 11.1667 45.014 11.5413 45.6808 12.208C46.3476 12.8748 46.7222 13.7792 46.7222 14.7222V18.2778Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_5023_22286">
                <rect width="63.9999" height="63.9999" fill="white" transform="translate(0.5 0.5)" />
              </clipPath>
            </defs>
          </svg>

          }
        </div>
      </div>

      <!-- Right Column: All Information -->
      <div class="tw-flex-1 tw-min-w-0 tw-flex tw-flex-col tw-justify-around tw-gap-1 md:tw-gap-1.5 md:tw-w-auto">
        <!-- Top Section: Name, Managed By, Badges -->
        <div class="md:tw-gap-4 tw-gap-1 md:tw-mb-px d-flex tw-flex-col tw-justify-around">
          <!-- Organization Name -->
          <div class="tw-flex-1">
            <h3
              class="tw-max-w-xs tw-truncate tw-font-inter tw-text-sm md:tw-text-base tw-font-bold tw-text-gray-900 dark:tw-text-gray-100 tw-leading-5 md:tw-leading-6 tw-tracking-normal tw-align-middle"
              [ngClass]="{ 'tw-text-right': _translationService.isRTL(), 'tw-text-left': !_translationService.isRTL() }"
              dir="auto"
              [ngxTippy]="isMobile() ? null : organization().name"
              [tippyProps]="{
                placement: _translationService.isRTL() ? 'top-end' : 'top-start'
              }"
            >
              {{ organization().name }}
            </h3>

            <!-- Managed By (if applicable) -->
            @if (showManagedBy() && organization().parent_workspace) {
            <p
              class="tw-text-xs tw-font-normal tw-font-inter d-flex tw-items-center tw-text-gray-500 dark:tw-text-gray-300 tw-mb-3 tw-leading-4 md:tw-leading-6 tw-tracking-normal tw-align-bottom"
              dir="auto"
            >
              <span class="tw-flex-shrink-0 tw-me-2">{{ 'v2.organizationCard.managedBy' | translate }} :</span>
              <span dir="auto" class="tw-truncate tw-align-middle" [ngxTippy]="isMobile() ? null : organization().parent_workspace.name">
                {{ organization().parent_workspace.name }}
              </span>
            </p>
            } @else {
            <p class="tw-mt-4"></p>
            }
          </div>
          <!-- Event Count Badges Row -->
          <div class="tw-flex tw-items-center tw-gap-1 md:tw-h-auto">
            <!-- Upcoming Events Badge -->
            <div
              class="tw-inline-flex tw-items-center tw-justify-center tw-text-sm tw-font-medium tw-rounded-md tw-px-0.5 tw-text-center tw-bg-yellow-100 dark:tw-bg-yellow-900 tw-text-yellow-800 dark:tw-text-yellow-300"
              [ngxTippy]="isMobile() ? null : getEventTooltip('upcoming')"
            >
              <span class="tw-w-2 tw-h-2 tw-rounded-full tw-ms-1 tw-bg-yellow-800 dark:tw-bg-yellow-300 tw-me-2"></span>
              {{ getUpcomingEventsCount() }}
            </div>

            <!-- Live Events Badge -->
            <div
              class="tw-inline-flex tw-items-center tw-justify-center tw-text-sm tw-font-medium tw-rounded-md tw-px-0.5 tw-text-center tw-bg-green-100 dark:tw-bg-green-900 tw-text-green-800 dark:tw-text-green-300"
              [ngxTippy]="isMobile() ? null : getEventTooltip('live')"
            >
              <span class="tw-w-2 tw-h-2 tw-rounded-full tw-ms-1 tw-bg-green-800 dark:tw-bg-green-300 tw-me-2"></span>
              {{ getLiveEventsCount() }}
            </div>
          </div>
        </div>

        <!-- Bottom Row: Member Avatars + Last Used -->
        <div class="tw-flex tw-items-center tw-justify-between">
          <!-- Member Avatars -->
          @if (memberAvatars().length > 0) {
          <div class="tw-flex tw-items-start">
            @for (member of memberAvatars().slice(0, 4); track member.id; let i = $index) {
            <div
              class="tw-relative tw-inline-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 md:tw-w-6 md:tw-h-6 tw-overflow-hidden tw-bg-gray-100 tw-rounded-full dark:tw-bg-gray-600"
              [ngClass]="{
                '-tw-ms-2': i > 0,
                'tw-hidden md:tw-flex': i >= 2
              }"
              [ngxTippy]="isMobile() ? null : member.email ? member.email : member.full_name"
            >
              @if (member.avatar) {
              <img [src]="member.avatar?.cropped_src || member.avatar?.original_src" [alt]="member.full_name" class="tw-object-contain" />
              } @else if (member.full_name && member.full_name !== 'Unknown User') {
              <span class="tw-font-medium tw-text-gray-600 dark:tw-text-gray-300 tw-text-xs">{{ member.initials || getInitials(member.full_name) }}</span>
              } @else {
              <!-- Flowbite User SVG fallback for users without name or icon -->
              <svg class="tw-absolute tw-text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"></path>
              </svg>
              }
            </div>
            }
            <!-- Overflow Count -->
            @if (totalMemberCount() > 2) {
            <div
              class="tw-relative tw-inline-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 md:tw-w-6 md:tw-h-6 tw-overflow-hidden tw-bg-gray-900 tw-rounded-full -tw-ms-2 tw-text-xs tw-font-medium tw-text-white tw-border tw-border-white dark:tw-border-gray-600"
              [ngClass]="{
                'md:hidden': totalMemberCount() <= 4,
                'hidden md:tw-flex': totalMemberCount() > 4
              }"
            >
              +{{ totalMemberCount() > 4 ? totalMemberCount() - 4 : totalMemberCount() - 2 }}
            </div>
            }
          </div>
          } @else {
          <!-- Empty State -->
          <div class="tw-text-gray-500 dark:tw-text-gray-300 tw-whitespace-nowrap tw-text-xs tw-font-normal tw-leading-6 tw-tracking-normal tw-text-start tw-align-bottom"></div>
          }

          <!-- Last Used Time -->
          <div
            class="tw-text-gray-500 dark:tw-text-gray-300 tw-whitespace-nowrap tw-text-xs tw-font-normal tw-leading-5 md:tw-leading-6 tw-tracking-normal tw-text-start tw-align-bottom"
          >
            {{ getLastUsedText() }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
